// extracted by mini-css-extract-plugin
export default {"page":"error-page_page__dlX5I","title":"error-page_title__MbyCc","message":"error-page_message__mkcNy","actions":"error-page_actions__t1S7M"};